// extracted by mini-css-extract-plugin
module.exports = {"compWrap":"Contests_compWrap__2Cj6N","header":"Contests_header__1pAUn","festivals":"Contests_festivals__2w7Tw"};